import { render, staticRenderFns } from "./sliderCreate.vue?vue&type=template&id=e5a44b52&"
import script from "./sliderCreate.vue?vue&type=script&lang=js&"
export * from "./sliderCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports